import * as React from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs'
import PropTypes from 'prop-types'
import { cn } from '../../lib/utils.js'

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.List
        ref={ref}
        className={cn(
            'grc-tabs inline-flex h-9 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground',
            className
        )}
        {...props} />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            'grc-tabs-trigger inline-flex items-center justify-center whitespace-nowrap px-0 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-b-4 border-indigo-500',
            className
        )}
        {...props} />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.Content
        ref={ref}
        className={cn(
            'mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            className
        )}
        {...props} />
))
TabsContent.displayName = TabsPrimitive.Content.displayName
Tabs.propTypes = {
    className: PropTypes.string
}

TabsList.propTypes = {
    className: PropTypes.string
}

TabsTrigger.propTypes = {
    className: PropTypes.string
}

TabsContent.propTypes = {
    className: PropTypes.string
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
